// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"861":"50ea4a1503480871","888":"76e6254697408431"}[chunkId] + ".css";
};